/**
 * Device utility functions for responsive behavior
 */

/**
 * Check if the current device is mobile
 * @returns {boolean} true if device is mobile, false otherwise
 */
export const isMobile = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  // Check screen width (mobile is typically < 768px)
  const isMobileWidth = window.innerWidth < 768;
  
  // Check user agent for mobile devices
  const userAgent = navigator.userAgent.toLowerCase();
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i;
  const isMobileUserAgent = mobileRegex.test(userAgent);
  
  // Return true if either condition is met
  return isMobileWidth || isMobileUserAgent;
};

/**
 * Check if the current device is tablet
 * @returns {boolean} true if device is tablet, false otherwise
 */
export const isTablet = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  const width = window.innerWidth;
  // Tablet range: 768px - 1023px (md breakpoint in Tailwind)
  return width >= 768 && width < 1024;
};

/**
 * Check if the current device is desktop
 * @returns {boolean} true if device is desktop, false otherwise
 */
export const isDesktop = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  // Desktop is typically >= 1024px (lg breakpoint in Tailwind)
  return window.innerWidth >= 1024;
};

/**
 * Get current device type
 * @returns {'mobile' | 'tablet' | 'desktop'} current device type
 */
export const getDeviceType = (): 'mobile' | 'tablet' | 'desktop' => {
  if (isMobile()) return 'mobile';
  if (isTablet()) return 'tablet';
  return 'desktop';
}; 